import React  from 'react';
import './App.css';
import './Page.css';

import { useNavigate } from "react-router-dom";

class PageNewFolder extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			folder: "",
		};
		
		this.onKeyDown = this.onKeyDown.bind(this);
		this.normalizeFilename = this.normalizeFilename.bind(this);
		this.onFolderChanged = this.onFolderChanged.bind(this);
		this.serverCreatePageFolder = this.serverCreatePageFolder.bind(this);
		this.onClickSaveButton = this.onClickSaveButton.bind(this);
		this.onClickCancelButton = this.onClickCancelButton.bind(this);
	}
	
	componentDidMount() {
	}
	
	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickSaveButton();
		}
	}

	normalizeFilename(filename1) {
		
		var i;
		var ch;
		var filename2 = "";
		var allowedYN;
		
		filename1 = filename1.toLowerCase();
		
		for(i=0; i<filename1.length; i++) {

			ch = filename1.charAt(i);

			allowedYN = false;
			if ((ch >= "0") && (ch <= "9")) {
				allowedYN = true;
			}
			if ((ch >= "a") && (ch <= "z")) {
				allowedYN = true;
			}
			
			if (allowedYN) {
				filename2 = filename2 + ch;
			}
		}
		
		return filename2;
	}

	onFolderChanged(value) {
		var folder = this.normalizeFilename(value);
		this.setState({folder: folder});
	}
	
	async serverCreatePageFolder(modelID, folder) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/createpagefolder?modelid=" + modelID;
		url = url + "&folder=" + encodeURIComponent(folder);
		
		const res = await fetch(url);
		var responseText = await res.text();

		if (responseText === "0") {
			this.props.showToast("New folder created");
		} else {
			this.props.showToast("New folder NOT created");
		}
		const navigate = this.props.navigate;
  		navigate("/pages");
	}
		
	onClickSaveButton() {
		
		var folder = this.state.folder;
		folder = folder.trim();
		if (folder === "") {
			this.props.showToast("Folder cannot be empty");
			return;
		}

		var modelID = this.props.modelID;
		this.serverCreatePageFolder(modelID, folder);

		var title;
		var changeJsonObj;
		var changeJSON;

		title = "New folder: " + folder;
		changeJsonObj = {};
		changeJsonObj.section = "pages";
		changeJsonObj.operation = "createfolder";
		changeJsonObj.pageFolder = folder;
		var changeJSON = JSON.stringify(changeJsonObj);
		this.props.serverInsertChangeLogRecord(title, changeJSON);
	}
	
	onClickCancelButton() {
		const navigate = this.props.navigate;
  		navigate("/pages");
	}
	
	render() {

		return (
			<div className="ViewContainer1">
				<div style={{height: "30px"}}></div>
				<div className="ViewTopTitle">New folder</div>
				<div className="ViewTopText">Enter folder name and press Create Folder bottun</div>

				<div style={{height: "30px"}}></div>
				<div className="ViewBlockContainer">
					<div style={{height: "15px"}}></div>
					<div className="ViewBlockTitle">Folder Info</div>
					<div style={{height: "20px"}}></div>
					<div className="ViewContainer2">
						<p></p>
						<fieldset className="PageNewFolderFieldset">
							<legend className="PageNewFolderLegend">Folder</legend> 
							<input
								className="PageNewFolderInput" 
								id="Document" 
								type="text" 
								autoFocus={true}
								value={this.state.folder}
								onChange={(event) => this.onFolderChanged(event.target.value)}
								onKeyDown={(event) => this.onKeyDown(event.keyCode)}
							/>
						</fieldset>
					</div>
					<div style={{height: "60px"}}></div>
					<div className="ViewContainerButtons">
						<div style={{width: "200px"}}></div>
						<button className="ViewCancelButton" onClick={this.onClickCancelButton}>Cancel</button>
						<div style={{width: "20px"}}></div>
						<button className="ViewSaveButton" onClick={this.onClickSaveButton}>Create Folder</button>
					</div>
					<div style={{height: "50px"}}></div>
				</div>

				<div style={{height: "100px"}}></div>
			</div>
		);
	}
}

export default function PageNewFolderFunction(props) {
	const navigate = useNavigate();
	return <PageNewFolder {...props} navigate={navigate} />;
}

